
import { Button, message, Tooltip } from 'antd';
import React from 'react';
import { api, use } from 'xadmin';
import { Icon } from 'xadmin-ui';

const FocusIcon = ({ item, button, styles }) => {
  const { modelDispatch } = use('model')
  const [selected, setSelected] = React.useState(item && item.focus)

  const onFocus = (id, focus) => {
    api({ name: 'core/node' }).fetch(`/${id}`, {
      headers: { "X-Forwarded-Method-Override": "GET" },
      method: 'PATCH',
      body: JSON.stringify({ 'focus': !focus })
    }).then(() => {
      setSelected(!focus)
      message.success(!focus ? '资产关注成功' : '取消资产关注成功')
      modelDispatch({ type: 'GET_ITEMS' })
    })
  }
  return (
    <Tooltip title="关注资产">
      {button ? <Button onClick={() => onFocus(item.id, selected)}>
        <Icon type="star" theme={selected ? 'filled' : ''} style={{ color: '#fadb14' }} />
      </Button> : <Icon type="star" theme={selected ? 'filled' : ''}
        onClick={() => onFocus(item.id, selected)} style={{ color: '#fadb14', ...styles }} />
      }
    </Tooltip>
  )
}

export default FocusIcon
